export default __webpack_public_path__ + "static/media/transaction.e1131905.svg";